
import { useState, useRef, useEffect } from 'react';
import moment from 'moment';

const CustomTaskDot = ({ cx, cy, color, status, tasks, showTooltip, setShowTooltip, setHoverTaskStatus, setHoveredTasks,top,left }) => {
    // const [showTooltip, setShowTooltip] = useState(false);
    const dotRef = useRef(null);
    const tooltipRef = useRef(null);
    const hoverTimeout = useRef(null);

    // const handleMouseEnter = () => {
    //     clearTimeout(hoverTimeout.current);
    //     setHoverTaskStatus(status);
    //     setHoveredTasks(tasks);

    //     setShowTooltip(true);
    // };

    const handleMouseClick = () => {
        setHoverTaskStatus(status);
        setHoveredTasks(tasks);

        setShowTooltip(!showTooltip);
    };

    const handleMouseLeave = () => {
        // Add a delay before hiding to allow moving mouse away
        hoverTimeout.current = setTimeout(() => {
            setShowTooltip(false);
            setHoverTaskStatus('');
            setHoveredTasks([]);
        }, 500); // 500ms delay
    };

    // Clean up timeout on unmount
    useEffect(() => {
        return () => {
            clearTimeout(hoverTimeout.current);
        };
    }, []);

    return (
        <>
            <circle
                ref={dotRef}
                cx={cx}
                cy={cy}
                r={6}
                fill={color}
                stroke="#fff"
                strokeWidth={1}
                // onMouseEnter={handleMouseEnter}
                // onMouseLeave={handleMouseLeave}
                onClick={handleMouseClick}
            />

            <div
                ref={tooltipRef}

                style={{
                    background: '#fff',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    zIndex: 1000,

                    overflowY: 'auto',

                }}
            >
                <p><strong>Status:</strong> {status}</p>
                <p><strong>Tasks ({tasks.length}):</strong></p>
                <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px' }}>
                    {tasks.map((task, i) => (
                        <li key={i} style={{ marginBottom: '5px' }}>
                            {task.taskName} (Due: {moment(task.endDate || task.selectDate).format('MMM D, YYYY')})
                        </li>
                    ))}
                </ul>
            </div>


        </>
    );
};

export default CustomTaskDot;